import EventEmitter from 'events';
import moment from 'moment';
// import auth0 from 'auth0-js'
// import config from '../../config.json'

const userlogin = 'islogged';
const userRefresh = 'isRefreshed';
const loginExpiryKey = 'tokenExpiry';
const loginRefreshExpiryKey = 'refreshTokenExpiry';

const Userinfo = 'user';
const Usertype = 'type';
const localStorageKey = 'loggedIn';
const maxTokenAge = 60 * 24;
const maxRefreshTokenAge = 60 * 24 * 30 * 6;
const maxRememberRefreshTokenAge = 60 * 24 * 30 * 12;

const primaryColor = "primary_color";
const secdondaryColor = "secondary_color";
const layoutVersion = "layoutVersion";
// const auth1 = new auth0.WebAuth({
//     domain: config.auth0.domain,
//     clientID: config.auth0.clientID,
//     responseType: 'id_token',
//     redirectUri:  window.location.origin + process.env.BASE_URL + "callback",
//     scope: 'openid profile' // define the scopes you want to use
// })

class Auth extends EventEmitter {
    type = null
    authToken = null
    userProfile = null
    tokenExpiry = null 
    refreshTokenExpiry = null 
    // Login With Jwt
    localLogin(authResult, Remember) {
        this.tokenExpiry = new moment().add(maxTokenAge, 'minutes');
        this.refreshTokenExpiry = new moment().add((Remember ? maxRememberRefreshTokenAge : maxRefreshTokenAge ), 'minutes');
        localStorage.setItem(loginExpiryKey, this.tokenExpiry);
        localStorage.setItem(loginRefreshExpiryKey, this.refreshTokenExpiry);
        localStorage.setItem(userlogin, 'true');
        localStorage.setItem(Userinfo, JSON.stringify(authResult));
    }

    refreshToken(authResult) {
        this.tokenExpiry = new moment().add(maxTokenAge, 'minutes');
        localStorage.setItem(loginExpiryKey, this.tokenExpiry);
        localStorage.setItem(userRefresh, 'true');

        //
        if (authResult.status.includes("Refreshed")) {
            // update
            let data = JSON.parse(localStorage.getItem(Userinfo))
            data.token = authResult.token 
            data.status = authResult.status
            data.refresh_time = authResult.refresh_time
            //
            localStorage.setItem(Userinfo, JSON.stringify(data));

        } else if (authResult.status.includes("Logged In")) {
            // 
            this.refreshTokenExpiry = new moment().add(maxRememberRefreshTokenAge, 'minutes');
            localStorage.setItem(Userinfo, JSON.stringify(authResult));
        }
    }

    updateUser(authResult) {
        // return only user
        const user = JSON.parse(localStorage.getItem(Userinfo))
        // update personal only
        user.name = authResult.name
        user.phone = authResult.phone

        // set
        localStorage.setItem(Userinfo, JSON.stringify(user));
    }

    Logout() {
        localStorage.removeItem(loginExpiryKey);
        localStorage.removeItem(userlogin);
        localStorage.removeItem(loginRefreshExpiryKey);
        localStorage.removeItem(Userinfo);
        localStorage.removeItem(userRefresh);
        // clear theme
        localStorage.removeItem(primaryColor);
        localStorage.removeItem(secdondaryColor);
        localStorage.removeItem(layoutVersion);
    }

    isAuthenticated() {
        return (
            new Date(Date.now()) <=  new Date(localStorage.getItem(loginExpiryKey)) &&
            localStorage.getItem(userlogin) === 'true'
        );
    }

    isAdmin(bool) {
        this.type = bool ? 'admin' : 'shop'
        localStorage.setItem(Usertype, this.type);
    }

    // login with Auth0
    // login () {
    //     auth1.authorize()
    // }

    // Handle Auth0 Callback
    // handleAuthentication () {
    // return new Promise((resolve, reject) => {
    //   auth1.parseHash((err, authResult) => {
    //     console.log('authResult', authResult);
    //     if (authResult.idToken) {
    //         console.log("Data", authResult)
    //         this.localAuthLogin(authResult);
    //         resolve(authResult)  
    //     }
    //     else if (err) {
    //         console.log("Error Occured", err.message)
    //         return reject(err)
    //     }
    //     })
    //   })
    // } 

    localAuthLogin(authResult) {        
        this.idToken = authResult.idToken;
        this.userProfile = authResult.idTokenPayload;
        this.tokenExpiry = new Date(this.userProfile.exp * 1000);
        console.log("userProfile", this.userProfile)
        localStorage.setItem(loginExpiryKey, this.tokenExpiry)
        localStorage.setItem(localStorageKey, 'true');
        localStorage.setItem(Userinfo, JSON.stringify({
            displayName: this.userProfile.name,
            email: this.userProfile.email,
            photoURL: this.userProfile.picture,
            providerId: this.userProfile.sub.substr(0, this.userProfile.sub.indexOf('|')),
            uid: this.userProfile.sub
        }))
    }

    logOut() {
        localStorage.removeItem(localStorageKey);
        localStorage.removeItem(loginExpiryKey);
        localStorage.removeItem(loginRefreshExpiryKey);
        localStorage.removeItem(Userinfo);
        localStorage.removeItem(userRefresh);
        this.idToken = null;
        this.tokenExpiry = null;
        this.refreshTokenExpiry = null;
        this.profile = null;
        // auth1.logout({
        //     returnTo: window.location.origin + process.env.BASE_URL
        // })
    }

    isAuthenticatedUser() {    
        let now = moment( new Date (Date.now()))
        let exp = moment(new Date (localStorage.getItem(loginExpiryKey)))

        let diff = (exp.diff(now, 'minutes') < 1) ? false : true

        return (
            diff && localStorage.getItem(localStorageKey) === 'true'
        );
    }
}

export default new Auth();
